import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';
import * as React from 'react';

export interface MenuItemProps extends MuiMenuItemProps {}

export const MenuItem = (props: MenuItemProps) => {
  return <MuiMenuItem {...props} />;
};
